module.exports = "<collection> <collection-item> <div> Vue <a href=#! class=secondary-content> <icon value=send></icon> </a> </div> </collection-item> <collection-item>React</collection-item> <collection-item>Angular</collection-item> <collection-item>Meteor</collection-item> <collection-item dismissable>This one is dismissable</collection-item> </collection>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/collections/basic-collection.vue
 ** module id = 228
 ** module chunks = 0
 **/